export default {
  kameraplaner: {
    intro: {
      badge: 'Mjet planifikimi interaktiv – falas dhe pa detyrim',
      title: 'Planifikoni paraprakisht sistemin tuaj të kamerave',
      lead:
        'Me planifikuesin e kamerave SSG mund të vizatoni dhoma ose sipërfaqe, të shënoni dyert, dritaret dhe zonat e rëndësishme të vëzhgimit dhe të testoni pozicionet e mundshme të kamerave. Merrni një vlerësim të parë vizual që më pas mund të kontrollohet profesionalisht nga SSG Signaltechnik.',
      noReg: 'Pa regjistrim',
      localSave: 'Ruhet lokalisht në shfletues',
      noBinding: 'Pa numër detyrues kamerash',
      quickTitle: 'Nis kontrollin e shpejtë',
      quickDesc:
        'Përgjigjuni në pesë hapa të shkurtër pyetjeve për objektin tuaj, zonat e dëshiruara të vëzhgimit dhe funksionet. Merrni menjëherë një përmbledhje të qartë.',
      quickList: { '0': 'Lloji i objektit dhe zonat për t’u vëzhguar', '1': 'Funksionet e dëshiruara dhe të dhënat e objektit', '2': 'Përmblidhni rezultatin dhe dërgojeni drejtpërdrejt' },
      quickCta: 'Nis kontrollin e shpejtë',
      plannerTitle: 'Planifikoni vetë skemën',
      plannerDesc:
        'Vizatoni dhoma dhe mure, vendosni dyer, dritare, pengesa dhe kamera – me kone shikimi, analizë mbulimi dhe sugjerime automatike pozicionesh.',
      plannerList: { '0': 'Sipërfaqe vizatimi me rrjet dhe shkallë në metra', '1': 'Kone shikimi, objektiva vëzhgimi dhe zona private', '2': 'Ngarkim skeme, vlerësim dhe printim' },
      plannerCta: 'Planifikoni vetë skemën',
      savedTitle: 'Ka një plan të ruajtur',
      savedDesc: 'U ruajt automatikisht lokalisht dhe mund të vazhdohet.',
      resume: 'Vazhdo planin e fundit',
    },
    quick: {
      steps: { '0': 'Lloji i objektit', '1': 'Zonat', '2': 'Funksionet', '3': 'Të dhënat e objektit', '4': 'Rezultati' },
      back: 'Kthehu te përmbledhja',
      title: 'Kontroll i shpejtë',
      subtitle: 'Pesë hapa të shkurtër – më pas merrni një përmbledhje të qartë të planifikimit tuaj paraprak.',
      stepOf: 'Hapi {{current}} nga {{total}}',
      objectQuestion: 'Cili lloj objekti ju përshtatet?',
      chooseOne: 'Ju lutemi zgjidhni një opsion.',
      areasQuestion: 'Cilat zona duhet të vëzhgohen?',
      multiSelect: 'Zgjedhje e shumëfishtë e mundur.',
      featuresTitle: 'Funksionet e dëshiruara',
      dataTitle: 'Të dhënat e objektit',
      dataOptional: 'Të gjitha të dhënat janë opsionale dhe mund të anashkalohen.',
      areaSize: 'Sipërfaqja e përafërt totale (m²)',
      roomCount: 'Numri i dhomave ose zonave',
      inOut: 'Brenda, jashtë apo të dyja?',
      inside: 'Brenda',
      outside: 'Jashtë',
      both: 'Të dyja',
      maxDistance: 'Distanca më e madhe e vlerësuar e vëzhgimit',
      pleaseSelect: 'Ju lutemi zgjidhni',
      distanceUpTo5: 'Deri në 5 metra',
      distance5to10: '5 deri në 10 metra',
      distance10to20: '10 deri në 20 metra',
      distanceOver20: 'Mbi 20 metra',
      internet: 'A ka lidhje interneti?',
      network: 'A ka kabllim rrjeti?',
      power: 'Rrymë në pikën e montimit?',
      yes: 'Po',
      no: 'Jo',
      unknown: 'E panjohur',
      recordingDuration: 'Kohëzgjatja e dëshiruar e regjistrimit',
      installType: 'Sistem i ri apo ekzistues?',
      newSystem: 'Sistem i ri',
      existingSystem: 'Sistem ekzistues',
      existingManufacturer: 'Prodhuesi dhe modeli i sistemit ekzistues (nëse dihet)',
      requirements: 'Kërkesa të veçanta',
      requirementsPlaceholder: 'Për shembull kushte të veçanta ndriçimi, mbrojtje monumentesh, kushte të veçanta...',
      chars: '{{current}}/500 karaktere',
      ssgCarePre: 'Më intereson gjithashtu',
      ssgCarePost: '– mirëmbajtja dhe kujdesi personal i sistemit.',
      overviewTitle: 'Planifikimi juaj paraprak në një vështrim',
      amberNote:
        'Bazuar në të dhënat tuaja mund të përshtaten disa pozicione ose lloje kamerash. Për një rekomandim të besueshëm duhet të kontrollohen këndet e shikimit, lartësia e montimit, ndriçimi dhe pengesat ekzistuese.',
      planFloorplan: 'Planifiko gjithashtu skemën',
      sendToSsg: 'Dërgo të dhënat te SSG',
      editResult: 'Modifiko rezultatin',
      backBtn: 'Prapa',
      next: 'Tjetra',
      summary: {
        objectType: 'Lloji i objektit',
        areas: 'Zonat e vëzhgimit',
        features: 'Funksionet e dëshiruara',
        areaSize: 'Sipërfaqja e përafërt totale',
        roomCount: 'Dhomat / zonat',
        inOut: 'Zona',
        maxDistance: 'Distanca më e madhe e vëzhgimit',
        internet: 'Lidhja e internetit',
        network: 'Kabllimi i rrjetit',
        power: 'Rryma në pikën e montimit',
        recordingDuration: 'Kohëzgjatja e regjistrimit',
        installType: 'Sistemi',
        existingSystem: 'Sistemi ekzistues',
        requirements: 'Kërkesa të veçanta',
        ssgCare: 'Kujdesi SSG Care',
      },
      values: {
        notSpecified: 'E paspecifikuar',
        inside: 'Brenda',
        outside: 'Jashtë',
        inOut: 'Brenda dhe jashtë',
        present: 'E disponueshme',
        notPresent: 'E padisponueshme',
        unknown: 'E panjohur',
        unclear: 'ende e paqartë',
        newSystem: 'Sistem i ri',
        existing: 'Sistem ekzistues',
        desired: 'E dëshiruar',
      },
    },
    topbar: {
      projectName: 'Emri i projektit',
      undo: 'Zhbëj',
      undoTip: 'Zhbëj (Ctrl+Z)',
      redo: 'Ribëj',
      redoTip: 'Ribëj (Ctrl+Y)',
      save: 'Ruaj përkohësisht',
      saved: 'U ruajt',
      saveTip: 'Ruaj përkohësisht',
      reset: 'Rivendos',
      resetTip: 'Rivendos planifikuesin',
      help: 'Ndihmë',
      helpTip: 'Hap përsëri hyrjen',
      evaluate: 'Vlerëso planin',
      evaluateTip: 'Vlerëso planin',
    },
    tools: {
      select: { label: 'Zgjidh', hint: 'Zhvendos, ndrysho madhësinë, rrotullo elementët. Tërhiq hapësirën bosh = zhvendos.' },
      erase: { label: 'Fshij', hint: 'Fshij elementin me klikim.' },
      room: { label: 'Dhomë drejtkëndore', hint: 'Vizato një dhomë ose sipërfaqe duke tërhequr – përmasat shfaqen drejtpërdrejt.' },
      polygon: { label: 'Sipërfaqe e lirë', hint: 'Vizato një sipërfaqe të lirë me dorë: mbaj të shtypur dhe vizato formën.' },
      wall: { label: 'Mur', hint: 'Vizato një mur duke tërhequr – kufizon linjat e shikimit.' },
      door: { label: 'Derë', hint: 'Vendos një derë në mur – pastaj zhvendos ose rrotullo drejtpërdrejt.' },
      window: { label: 'Dritare', hint: 'Vendos një dritare në mur – pastaj zhvendos ose rrotullo drejtpërdrejt.' },
      obstacle: { label: 'Pengesë', hint: 'Vizato një kolonë, raft, ndarje ose bllok mobiljesh.' },
      watch: { label: 'Objektiv vëzhgimi', hint: 'Shëno një zonë të rëndësishme që duhet kapur.' },
      privacy: { label: 'Zonë private', hint: 'Shëno një zonë që nuk duhet kapur.' },
      camera: { label: 'Kamera', hint: 'Vendos një kamerë me klikim. Djathtas hapet menuja e modeleve – modeli i përshtatshëm është tashmë i rekomanduar.' },
      text: { label: 'Tekst', hint: 'Shto emra dhomash ose etiketa.' },
    },
    editor: {
      tools: 'Mjetet',
      autoSuggest: 'Sugjerime automatike',
      analysis: 'Analiza e mbulimit',
      properties: 'Vetitë',
      backToIntro: 'Kthehu te përmbledhja e planifikuesit të kamerave',
      resetTitle: 'Të rivendoset planifikuesi?',
      resetText:
        'Të gjithë elementët e vizatuar, kamerat dhe skema e ngarkuar do të fshihen përgjithmonë. Plani i ruajtur do të hiqet.',
      cancel: 'Anulo',
      confirmReset: 'Po, rivendos',
      close: 'Mbyll',
      openTools: 'Hap mjetet',
      openAnalysis: 'Hap analizën',
      snap: 'Aktivizo/çaktivizo kapjen në rrjet',
      zoomIn: 'Zmadho',
      zoomOut: 'Zvogëlo',
      fit: 'Qendërzoni skemën',
      closeHints: 'Mbyll këshillat',
    },
    canvas: {
      areaLabel: 'Sipërfaqja e vizatimit të skemës',
      calibHint: 'Ju lutemi caktoni një distancë për shkallëzimin',
      locked: 'i kyçur',
      scale: 'Shkalla: përaf. {{px}} px/m · Rrjeti {{step}} m',
      calibNotice: 'Klikoni dy pika në skemë distancën e të cilave e dini.',
    },
    props: {
      edit: 'Modifiko vetitë',
      delete: 'Fshij',
      cameraModel: 'Modeli i kamerës (pajisje reale)',
      nameNumber: 'Emri / numri',
      cameraCategory: 'Kategoria e kamerës',
      modelAssigned: 'Modeli „{{series}}“ është caktuar.',
      planningValues: 'Këto janë vlera planifikimi – jo të dhëna teknike të një produkti real.',
      visibility: 'Dukshmëria',
      recognition: 'Njohja',
      detail: 'Detaji',
      rotation: 'Orientimi (°)',
      fov: 'Këndi i shikimit (°)',
      range: 'Gama (m)',
      posX: 'Pozicioni X (m)',
      posY: 'Pozicioni Y (m)',
      mountHeight: 'Lartësia e montimit (m)',
      indoor: 'Brenda',
      outdoor: 'Jashtë',
      usage: 'Fusha e përdorimit',
      dayNight: 'Ditë / natë',
      target: 'Objektivi i dëshiruar i vëzhgimit',
      noneAssigned: 'Asgjë e caktuar',
      targetArea: 'Zona objektiv',
      remark: 'Shënim',
      remarkPlaceholder: 'p.sh. shënime për montimin ose ambientin...',
      coneNote: 'Koni i shikimit është një paraqitje planifikimi. Cilësia reale e imazhit varet nga modeli, lentja, distanca, lartësia e montimit, drita dhe pengesat në vend.',
      roomLabel: 'Emërtimi i dhomës',
      length: 'Gjatësia (m)',
      width: 'Gjerësia (m)',
      area: 'Sipërfaqja: përaf. {{area}} m²',
      designation: 'Emërtimi',
      points: '{{count}} pika – zhvendosni pikat drejtpërdrejt në sipërfaqen e vizatimit.',
      wallThickness: 'Trashësia e murit (m)',
      wallLength: 'Gjatësia: përaf. {{length}} m',
      wallNote: 'Muret e vizatuara të ngurta kufizojnë linjat e shikimit në planifikues.',
      obstacleKind: 'Lloji i pengesës',
      shape: 'Forma',
      rect: 'Drejtkëndësh',
      circle: 'Rreth',
      caption: 'Etiketa',
      diameter: 'Diametri (m)',
      depth: 'Thellësia (m)',
      goalKind: 'Lloji i objektivit',
      priority: 'Prioriteti',
      goal: 'Objektivi i dëshiruar',
      coverageNote: 'Mbulimi vlerësohet me ngjyra (jeshile / të verdhë / të kuqe). Për objektivat me detaje vlejnë kërkesa më të rrepta.',
      zoneKind: 'Lloji i zonës',
      privacyNote: 'Nëse një kon shikimi mbivendoset me këtë zonë, shfaqet një paralajmërim në analizë.',
      textContent: 'Përmbajtja e tekstit',
      duplicate: 'Dubliko',
      deleteElement: 'Fshij elementin',
      projectData: 'Të dhënat e projektit',
      noElement: 'Asnjë element i zgjedhur',
      projectName: 'Emri i projektit',
      objectType: 'Lloji i objektit',
      objectTypePlaceholder: 'p.sh. shtëpi njëfamiljare',
      projectDescription: 'Përshkrimi i projektit',
      projectDescriptionPlaceholder: 'Veçoritë, dëshirat ose kushtet e përgjithshme...',
      maxChars: 'Maksimumi 500 karaktere',
      cameraForNew: 'Modeli i kamerës për kamerat e reja',
      cameraForNewDesc: 'Zgjidhni më poshtë modelin e dëshiruar Safire – menuja hapet automatikisht. Kamerat e reja vendosen me këto cilësime.',
      recommendedFor: 'E rekomanduar për sipërfaqen tuaj:',
      orGeneric: 'ose kategori gjenerike',
      tips: 'Këshilla',
      tip1: 'Tërhiqni hapësirën bosh me mjetin e përzgjedhjes = zhvendosni sipërfaqen. Rrota e miut = zmadhim.',
      tip2: 'Ctrl+Z = zhbëj, Ctrl+Y = ribëj, Del = fshij elementin.',
      tip3: 'Kapja në rrjet mund të aktivizohet/çaktivizohet te opsionet e shikimit.',
      suggestPositions: 'Sugjero automatikisht pozicionet e kamerave',
      doorSwing: 'Drejtimi i hapjes',
      left: 'Majtas',
      right: 'Djathtas',
      none: 'Asnjë',
      attached: 'E vendosur në një mur – tërhiqeni përgjatë murit për ta zhvendosur. Me rrotullim elementi çlirohet.',
      detached: 'E vendosur lirisht – zhvendoseni dhe rrotullojeni lirisht.',
      doorNote: 'Materiali, xhamat dhe gjendja e hapjes duhet të kontrollohen në vend.',
    },
    result: {
      edit: 'Modifiko planin',
      print: 'Printo përmbledhjen',
      savePdf: 'Ruaj si PDF',
      send: 'Dërgo planin te SSG',
      eyebrow: 'Vlerësimi',
      title: 'Planifikimi juaj paraprak në një vështrim',
      disclaimer:
        'Ky vlerësim është një planifikim paraprak jo detyrues. Një rekomandim përfundimtar bëhet vetëm pas kontrollit të kushteve lokale dhe zgjedhjes së teknikës konkrete të kamerave.',
      project: 'Projekti',
      objectType: 'Lloji i objektit:',
      uploadPresent: 'Ngarkimi i skemës i disponueshëm:',
      scaled: 'i shkallëzuar',
      refDistance: 'm distancë reference',
      notScaled: 'ende i pashkallëzuar',
      createdAt: 'Krijuar më',
      floorplan: 'Skema e vizatuar',
      noElements: 'Ende nuk ka elementë në skemë.',
      stats: { rooms: 'Dhomat dhe sipërfaqet', walls: 'Muret', doors: 'Dyert', windows: 'Dritaret', obstacles: 'Pengesat', cameras: 'Kamerat', zones: 'Zonat objektiv', privacy: 'Zonat private' },
      zonesTitle: 'Objektivat e vëzhgimit dhe prioritetet',
      noZones: 'Nuk ka objektiva vëzhgimi të shënuara.',
      priorityLabel: 'Prioriteti',
      goalLabel: 'Objektivi',
      goalOverview: 'Përmbledhje',
      goalDetail: 'Detaj',
      goalObservation: 'Vëzhgim',
      coverage: 'mbulim gjeometrik',
      camerasTitle: 'Pozicionet dhe llojet e kamerave',
      noCameras: 'Ende nuk ka kamera të vendosura.',
      modelLabel: 'Modeli',
      fovLabel: 'Këndi i shikimit',
      visibilityLabel: 'Dukshmëria përaf.',
      recognitionLabel: 'Njohja përaf.',
      detailLabel: 'Detaji përaf.',
      positionLabel: 'Pozicioni',
      rotationLabel: 'Orientimi',
      rangeLabel: 'Gama përaf.',
      mountLabel: 'Lartësia e montimit',
      indoor: 'Brenda',
      outdoor: 'Jashtë',
      day: 'Ditë',
      night: 'Natë',
      dayNight: 'Ditë dhe natë',
      target: 'Objektivi',
      assigned: 'I caktuar',
      modelNote:
        'Modelet e zgjedhura Safire bazohen në vlerat e fletës së të dhënave; dukshmëria/njohja/detaji janë vlera planifikimi të llogaritura (EN 62676-4). Pa model vlerat janë gjenerike – jo të dhëna teknike të një produkti real.',
      blindTitle: 'Pika të verbëra të mundshme dhe çështje të hapura',
      uncovered: 'Zonat e pamjaftueshme të mbuluara:',
      privacyOverlaps: 'Mbivendosjet me zonat private:',
      checkPrivacy: 'Kontrolloni pozicionin, orientimin ose maskimin.',
      missingTitle: 'Të dhëna të rëndësishme që mungojnë',
      quickTitle: 'Funksionet e dëshiruara dhe të dhënat e objektit',
      areasLabel: 'Zonat:',
      featuresLabel: 'Funksionet:',
      areaLabel: 'Sipërfaqja:',
      recordingLabel: 'Regjistrimi:',
      internetLabel: 'Interneti:',
      powerLabel: 'Rryma:',
      careInterest: 'Interes për kujdesin SSG Care',
      finalNote: 'Plani do të kontrollohet profesionalisht nga SSG Signaltechnik. Lartësia e montimit, ndriçimi, këndet dhe kushtet në vend vendosin për zbatimin përfundimtar.',
      sendBottom: 'Dërgo planin te SSG Signaltechnik',
      consult: 'Kërkoni konsultim personal',
      good: 'I mbuluar mirë',
      partial: 'Pjesërisht i mbuluar',
      insufficient: 'I pamjaftueshëm',
    },
    send: {
      back: 'Prapa',
      title: 'Dërgo planin te SSG Signaltechnik',
      lead:
        'Të dhënat tuaja të planifikimit (skema, kamerat, këndet e shikimit, objektivat e vëzhgimit, zonat private dhe rezultati i analizës) transmetohen së bashku me të dhënat tuaja të kontaktit. Të dhënat e kontaktit nevojiten vetëm tani – vetë plani mbetet lokalisht në pajisjen tuaj.',
      dataTitle: 'Të dhënat e planifikimit të transmetuara',
      floorplan: 'Skema',
      rooms: 'Dhomat/sipërfaqet',
      walls: 'Muret',
      doors: 'Dyert',
      windows: 'Dritaret',
      obstacles: 'Pengesat',
      cameras: 'Kamerat',
      none: 'asnjë',
      zones: 'Objektivat e vëzhgimit',
      privacy: 'Zonat private',
      analysis: 'Analiza',
      good: 'mirë',
      partial: 'pjesërisht',
      insufficient: 'i pamjaftueshëm i mbuluar',
      upload: 'Ngarkimi i skemës',
      scaled: 'i shkallëzuar',
      notScaled: 'i pashkallëzuar',
      customerType: 'Klient privat apo biznesi *',
      privateCustomer: 'Klient privat',
      businessCustomer: 'Klient biznesi',
      name: 'Emri dhe mbiemri *',
      company: 'Kompania (opsionale)',
      phone: 'Numri i telefonit',
      email: 'Adresa e emailit *',
      projectAddress: 'Adresa e projektit',
      projectAddressPlaceholder: 'Rruga, kodi postar, qyteti',
      contactPref: 'Mënyra e preferuar e kontaktit',
      any: 'S’ka rëndësi',
      byPhone: 'Telefon',
      byEmail: 'Email',
      callbackTime: 'Koha e preferuar e thirrjes',
      noCallback: 'Nuk dua thirrje',
      morning: 'Paradite',
      afternoon: 'Pasdite',
      evening: 'Mbrëmje',
      systemStatus: 'Sistem i ri apo ekzistues',
      newSystem: 'Sistem i ri',
      existingSystem: 'Sistem ekzistues',
      unsure: 'Ende i pasigurt',
      existingManufacturer: 'Prodhuesi i një sistemi ekzistues (nëse dihet)',
      existingManufacturerPlaceholder: 'p.sh. Hikvision, Safire...',
      careInterest: 'Interes për SSG Care',
      careYes: 'Po, ju lutem më informoni',
      careNo: 'Jo',
      careLater: 'Vendos më vonë',
      message: 'Mesazh shtesë',
      messagePlaceholder: 'Shtesa për planin tuaj...',
      fileUpload: 'Skema / foto (opsionale)',
      fileNote: 'Shënim: ngarkimet e skedarëve trajtohen si „Uncollectable“ – të dhënat e planifikimit transmetohen si tekst.',
      privacyConsent:
        'Kam lexuar deklaratën e privatësisë dhe pajtohem me përpunimin e të dhënave të mia për trajtimin e kësaj kërkese. Të dhënat e planifikimit përdoren ekskluzivisht për trajtimin. *',
      privacyLink: 'Deklarata e privatësisë',
      error: 'Ndodhi një gabim. Ju lutemi provoni përsëri më vonë.',
      networkError: 'Gabim rrjeti. Kontrolloni lidhjen tuaj dhe provoni përsëri.',
      successTitle: 'Faleminderit për planin tuaj.',
      successText: 'SSG Signaltechnik do të kontrollojë të dhënat tuaja dhe do t’ju kontaktojë personalisht.',
      sending: 'Po dërgohet...',
      submit: 'Dërgo planin te SSG',
      backToResult: 'Kthehu te vlerësimi',
    },
    tour: {
      stepOf: 'Hapi {{current}} nga {{total}}',
      skip: 'Kapërce',
      back: 'Prapa',
      next: 'Tjetra',
      finish: 'Le të fillojmë',
      dialogLabel: 'Hyrje në planifikuesin e kamerave',
      steps: {
        '0': { title: 'Mirë se vini te planifikuesi i kamerave SSG', text: 'Vizatoni dhomën tuaj ose ngarkoni një skemë.' },
        '1': { title: 'Shënoni zonat', text: 'Shënoni dyert, dritaret dhe zonat e rëndësishme.' },
        '2': { title: 'Vendosni kamerat', text: 'Vendosni kamerat ose lini të sugjerohen pozicionet.' },
        '3': { title: 'Kontrolloni fushat e shikimit', text: 'Kontrolloni fushat e shikimit dhe pikat e mundshme të verbëra.' },
        '4': { title: 'Dërgoni planin', text: 'Dërgoni planifikimin paraprak te SSG Signaltechnik.' },
      },
    },
    analysis: {
      title: 'Analiza e mbulimit',
      suggest: 'Sugjero pozicionet',
      suggestTip: 'Sugjero pozicionet e kamerave',
      cameras: 'Kamerat',
      zones: 'Zonat objektiv',
      good: 'I mbuluar mirë',
      partial: 'Pjesërisht',
      notCovered: 'I pambuluar',
      privacyConflict: 'Konflikt i zonës private',
      areaCoverage: 'Mbulimi gjeometrik i sipërfaqes',
      areaNote: 'Mbulim i paraqitur gjeometrikisht – asnjë deklaratë për cilësinë reale të imazhit apo njohjes.',
      legend: 'Legjenda',
      legendFov: 'Fusha e shikimit të kamerës',
      legendDetail: 'Njohje e mprehtë e detajeve (me vija të ndërprera)',
      legendGood: 'Objektivi i mbuluar mirë',
      legendPartial: 'Objektivi pjesërisht i mbuluar',
      legendBad: 'Objektivi i pamjaftueshëm',
      legendPrivacy: 'Zonë private / e përjashtuar',
      note: 'Vlerësimi me ngjyra është një orientim gjeometrik. Një kënd i gjerë shikimi nuk do të thotë automatikisht njohje e mjaftueshme detajesh – duhet të kontrollohen distanca, rezolucioni dhe lartësia e montimit.',
    },
    upload: {
      title: 'Ngarko skemën',
      desc: 'Opsionale: ngarkoni një skemë ekzistuese (JPG, PNG ose WebP) si sfond. Më pas shënoni një distancë të njohur dhe vendosni gjatësinë e saj që planifikuesi të shkallëzojë saktë.',
      choose: 'Zgjidh skemën',
      chooseOther: 'Zgjidh një imazh tjetër',
      remove: 'Hiq',
      calibPrompt: 'Tani klikoni pikën A dhe pikën B në skemë në sipërfaqen e vizatimit.',
      startCalib: 'Nis shkallëzimin',
      scaled: 'E shkallëzuar: {{cm}} cm për piksel · Distanca {{m}} m',
      lengthPlaceholder: 'Gjatësia në metra',
      apply: 'Apliko',
      opacity: 'Opaciteti {{pct}} %',
      lock: 'Kyç sfondin (parandalon zhvendosjen aksidentale)',
      moveHint: 'Për të zhvendosur: tërhiqni një vend bosh në imazh me mjetin e përzgjedhjes (nëse nuk është i kyçur).',
      privacyNote: 'Skemat dhe fotot e objektit mund të përmbajnë informacion të ndjeshëm. Ngarkoni vetëm skedarët e nevojshëm për trajtimin e kërkesës suaj.',
      onlyImages: 'Ju lutemi zgjidhni vetëm imazhe JPG, PNG ose WebP.',
      tooLarge: 'Skedari është shumë i madh. Ju lutemi zgjidhni një imazh nën 8 MB.',
      readError: 'Skedari nuk mund të lexohej.',
      validLength: 'Ju lutemi vendosni një gjatësi të vlefshme në metra.',
      tooClose: 'Pikat e shënuara janë shumë afër njëra-tjetrës.',
    },
    picker: {
      generic: 'Zgjidh kategorinë gjenerike',
      genericOption: 'Kategori gjenerike (pa model)',
      recommended: 'E rekomanduar',
      recommendation: 'Rekomandim për sipërfaqen tuaj',
      fovLabel: 'Këndi i shikimit',
      detailFrom: 'Detaj nga përaf. {{detail}} m · Njohje përaf. {{recognition}} m',
      hFov: 'Këndi horizontal i shikimit',
      vFov: 'Këndi vertikal i shikimit',
      resolution: 'Rezolucioni',
      lens: 'Lentja',
      irRange: 'Gama IR',
      ipClass: 'Klasa e mbrojtjes',
      audio: 'Audio',
      dayNight: 'Ditë / natë',
      datenblatt: 'Fletë e të dhënave',
      planungswert: 'Vlerë planifikimi',
      doriNote:
        'Dukshmëria/njohja/detaji: vlera planifikimi të llogaritura sipas EN 62676-4 (densiteti i pikselëve). Cilësia reale e imazhit varet nga modeli, lentja, lartësia e montimit, drita dhe pengesat në vend.',
      groups: { standard: 'Standarde / brenda dhe jashtë', outdoor: 'Jashtë', panorama180: 'Panoramë', ptz: 'Rrotullim / zmadhim' },
    },
    quickswitch: {
      title: 'Ndrysho modelin e kamerës',
      subtitle: 'Ndrysho variantin drejtpërdrejt',
      active: 'Aktiv',
      recommended: 'E rekomanduar',
      note: 'Vendosni orientimin, gamën dhe lartësinë e montimit në panelin e vetive në të djathtë.',
      close: 'Mbyll përzgjedhjen e modelit',
    },
    elementTypes: {
      room: 'Dhomë / sipërfaqe',
      polygon: 'Sipërfaqe e lirë',
      wall: 'Mur',
      door: 'Derë',
      window: 'Dritare',
      obstacle: 'Pengesë',
      watchzone: 'Objektiv vëzhgimi',
      privacy: 'Zonë private / përjashtim',
      camera: 'Kamera',
      text: 'Tekst',
    },
    defaults: { room: 'Dhomë', watchzone: 'Zonë objektiv', text: 'Emri i dhomës' },
    defaultProject: 'Plani im i kamerave',
    quickProject: 'Planifikimi i kamerave (kontroll i shpejtë)',
    options: {
      objectTypes: {
        Einfamilienhaus: 'Shtëpi njëfamiljare',
        Mehrfamilienhaus: 'Ndërtesë banimi',
        Wohnung: 'Apartament',
        'Ladengeschäft': 'Dyqan',
        'Büro oder Praxis': 'Zyrë ose ordinancë',
        Gastronomie: 'Gastronomi',
        'Lager oder Logistik': 'Magazinë ose logjistikë',
        Werkstatt: 'Punishte',
        'Parkplatz oder Außenfläche': 'Parking ose sipërfaqe e jashtme',
        Baustelle: 'Kantier',
        Sonstiges: 'Tjetër',
      },
      areas: {
        Haupteingang: 'Hyrja kryesore',
        Nebeneingang: 'Hyrja dytësore',
        Fenster: 'Dritarja',
        Einfahrt: 'Rrugëdalja',
        Garage: 'Garazhi',
        'Garten oder Terrasse': 'Kopshti ose tarraca',
        Kasse: 'Arka',
        Verkaufsfläche: 'Sipërfaqja e shitjes',
        Lager: 'Magazina',
        Lieferzone: 'Zona e dorëzimit',
        Parkplatz: 'Parkingu',
        'Büro oder Innenraum': 'Zyrë ose brendësi',
        'Gesamte Außenfläche': 'E gjithë sipërfaqja e jashtme',
        'Sonstiger Bereich': 'Zonë tjetër',
      },
      features: {
        'Live-Ansicht': 'Pamje live',
        'lokale Aufzeichnung': 'Regjistrim lokal',
        'Smartphone-Zugriff': 'Qasje me smartphone',
        'Wiedergabe gespeicherter Aufnahmen': 'Riprodhimi i regjistrimeve të ruajtura',
        Ereignisbenachrichtigungen: 'Njoftime ngjarjesh',
        'gute Sicht bei Dunkelheit': 'Shikim i mirë në errësirë',
        'Übersicht über eine große Fläche': 'Përmbledhje e një sipërfaqeje të madhe',
        'Erkennung wichtiger Details': 'Njohja e detajeve të rëndësishme',
        'mehrere Benutzer': 'Disa përdorues',
        'mehrere Standorte': 'Disa vendndodhje',
        'vorhandene Anlage erweitern': 'Zgjero sistemin ekzistues',
        'SSG-Care-Betreuung': 'Kujdesi SSG Care',
      },
      recordingDurations: {
        'Bis 7 Tage': 'Deri në 7 ditë',
        'Bis 14 Tage': 'Deri në 14 ditë',
        'Bis 30 Tage': 'Deri në 30 ditë',
        'Mehr als 30 Tage': 'Më shumë se 30 ditë',
        'noch unklar': 'ende e paqartë',
      },
      roomNames: {
        Eingang: 'Hyrje',
        Flur: 'Korridor',
        Wohnzimmer: 'Dhomë ndenjeje',
        'Büro': 'Zyrë',
        Verkaufsfläche: 'Sipërfaqe shitjeje',
        Kasse: 'Arkë',
        Lager: 'Magazinë',
        Werkstatt: 'Punishte',
        Parkplatz: 'Parking',
        Außenbereich: 'Zonë e jashtme',
      },
      obstacles: {
        saeule: 'Kolona',
        regal: 'Raft',
        trennwand: 'Ndarje e lartë',
        moebel: 'Bllok mobiljesh',
        fahrzeug: 'Vend parkimi mjeti',
        eigen: 'Pengesë e emërtuar',
      },
      watchKinds: {
        ueberblick: 'Mbikëqyr plotësisht zonën',
        eingang: 'Vëzhgo hyrjen',
        tuer: 'Mbikëqyr derën',
        fenster: 'Mbikëqyr dritaren',
        kasse: 'Kap arkën ose pikën e ndjeshme',
        zufahrt: 'Vëzhgo rrugëdaljen',
        kennzeichen: 'Kontrollo zonën e targave',
        flaeche: 'Përmbledhje e një sipërfaqeje',
        details: 'Njohe detaje të rëndësishme',
        individuell: 'Zonë individuale',
      },
      watchPriorities: { normal: 'Normal', wichtig: 'E rëndësishme', kritisch: 'Kritike' },
      watchGoals: { uebersicht: 'Përmbledhje', beobachtung: 'Vëzhgim', detail: 'Detaj' },
      privacyKinds: {
        privat: 'Zonë private',
        nachbar: 'Pronë e fqinjit',
        oeffentlich: 'Trotuar ose rrugë publike',
        mitarbeiter: 'Zonë e punonjësve',
        ausgeschlossen: 'Zonë që nuk duhet kapur',
      },
      categories: {
        standard: { label: 'Kamerë standarde', hint: 'E gjithanshme për brenda dhe jashtë' },
        wide: { label: 'Kamerë me kënd të gjerë', hint: 'Përmbledhje e gjerë në distancë të shkurtër/të mesme' },
        varifocal: { label: 'Kamerë me kënd të ndryshueshëm', hint: 'Këndi rregullohet në vend' },
        panorama180: { label: 'Kamerë panoramike 180°', hint: 'Kapje shumë e gjerë, njohje detajesh e kufizuar' },
        fisheye360: { label: 'Kamerë 360° / sy peshku', hint: 'Pamje gjithëpërfshirëse, imazhi korrigjohet elektronikisht' },
        ptz: { label: 'Kamerë PTZ', hint: 'Kamerë rrotullimi/animimi/zmadhimi për sipërfaqe më të mëdha' },
        indoor: { label: 'Kamerë e brendshme', hint: 'E optimizuar për brendësi' },
        outdoor: { label: 'Kamerë e jashtme', hint: 'Version rezistent ndaj motit për jashtë' },
      },
      dayNight: { tag: 'Ditë', nacht: 'Natë', beides: 'Ditë dhe natë' },
    },
    models: {
      'safire-turret-i1-4mp': { ai: 'Klasifikimi i personave dhe mjeteve (AI)', note: 'Kamerë turret e gjithanshme me kënd të gjerë shikimi – standard i mirë për brenda dhe jashtë.' },
      'safire-turret-e1-4mp': { ai: 'Klasifikimi i personave dhe mjeteve (AI)', note: 'Model fillestar i përballueshëm i serisë E1 me rezolucion solid.' },
      'safire-turret-b1-4mp': { ai: '', note: 'Turret economy e fortë me trup rezistent ndaj goditjeve (IK10).' },
      'safire-dome-i2-8mp': { ai: 'Klasifikimi i personave dhe mjeteve (AI)', note: 'Rezolucion i lartë 8 MP – më shumë detaj në të njëjtën kornizë.' },
      'safire-bullet-4mp': { ai: 'Klasifikimi i personave dhe mjeteve (AI)', note: 'Dizajn klasik bullet për montim të jashtëm. Këndi i shikimit si vlerë planifikimi sipas serisë.' },
      'safire-turret-nightcolor-4mp': { ai: 'Imazh me ngjyra në errësirë (NightColor X)', note: 'Jep imazh me ngjyra edhe në dritë të ulët – ideal për situata kritike natën. Këndi i shikimit si vlerë planifikimi.' },
      'safire-turret-duallight-4mp': { ai: 'Klasifikimi i personave dhe mjeteve (AI)', note: 'DualLight me LED infra të kuqe dhe dritë të bardhë (30 m secili) – fleksibël natën. Këndi i shikimit si vlerë planifikimi.' },
      'safire-panorama-180-8mp': { ai: 'Pamje 180° me altoparlant dhe mikrofon', note: 'Kap një zonë shumë të gjerë me një kamerë – njohja e detajeve në distancë është e kufizuar.' },
      'safire-miniptz-4mp': { ai: 'Ndjekje automatike, klasifikim i personave dhe mjeteve', note: 'Kamerë PTZ me ndjekje automatike. Këndi i shikimit si vlerë planifikimi (pozicioni përfundimtar me kënd të gjerë).' },
      'safire-ptz-15x-2mp': { ai: 'Ndjekje automatike, ndjekje e makinave dhe mjeteve', note: 'Gamë e madhe falë zmadhimit 15× dhe IR 200 m. Këndi i shikimit si vlerë planifikimi (pozicioni përfundimtar me kënd të gjerë).' },
    },
    disclaimer: {
      general:
        'Planifikuesi i kamerave ofron një planifikim paraprak jo detyrues. Korniza reale e imazhit dhe pozicioni i përshtatshëm i kamerës varen ndër të tjera nga modeli, lentja, distanca, lartësia e montimit, ndriçimi, pengesat dhe kushtet në vend.',
      result:
        'Ky vlerësim është një planifikim paraprak jo detyrues. Një rekomandim përfundimtar bëhet vetëm pas kontrollit të kushteve lokale dhe zgjedhjes së teknikës konkrete.',
      upload: 'Skemat dhe fotot e objektit mund të përmbajnë informacion të ndjeshëm. Ngarkoni vetëm skedarët e nevojshëm për trajtimin e kërkesës suaj.',
      sichtfeld: 'Dyert dhe dritaret mund të ndikojnë në linjat e shikimit. Materiali, xhamat, gjendja e hapjes dhe reflektimi i dritës duhet të kontrollohen në vend.',
      datenschutz:
        'Për kërkesa si njohja e fytyrës, identifikimi i personave ose njohja e targave kërkohet një kontroll teknik dhe i mbrojtjes së të dhënave.',
    },
    hints: {
      '0':
        'Bazuar në të dhënat tuaja mund të përshtaten disa pozicione ose lloje kamerash. Për një rekomandim të besueshëm duhet të kontrollohen këndet e shikimit, lartësia e montimit, ndriçimi dhe pengesat ekzistuese.',
      '1':
        'Një kënd i gjerë shikimi nuk do të thotë automatikisht njohje e mjaftueshme detajesh. Distanca, rezolucioni, këndi, lartësia e montimit dhe objektivi ndikojnë në cilësinë reale të imazhit.',
      '2': 'Lartësia e montimit dhe kushtet e ndriçimit duhet të kontrollohen në vend.',
    },
    recommend: {
      noArea: 'Rekomandim standard për sa kohë nuk është vizatuar asnjë sipërfaqe. Vizatoni dhomën tuaj dhe rekomandimi do të përshtatet.',
      veryLarge: 'Sipërfaqe shumë e madhe (përaf. {{area}} m²) – PTZ me zmadhim dhe gamë të madhe për distanca të gjera.',
      large: 'Sipërfaqe e madhe (përaf. {{area}} m²) – dizajn i fortë bullet për jashtë.',
      medium: 'Sipërfaqe e mesme deri e madhe (përaf. {{area}} m²) – 8 MP për më shumë detaj në gjerësi.',
      compact: 'Sipërfaqe kompakte (përaf. {{area}} m²) – një kënd i gjerë shikimi e mbulon mirë dhomën.',
    },
    analysisDynamic: {
      missingNoCameras: 'Ende nuk ka kamera të vendosura.',
      missingNoRooms: 'Ende nuk janë vizatuar dhoma ose sipërfaqe.',
      missingNoWalls: 'Nuk janë vizatuar mure – konet e shikimit nuk kufizohen.',
      missingNoZones: 'Nuk ka objektiva vëzhgimi të shënuara.',
      missingNoPrivacy: 'Nuk ka zona private ose përjashtimi të shënuara.',
      missingNoInternet: 'Mungon informacioni për lidhjen e internetit.',
      missingNoPower: 'Mungon informacioni për furnizimin me rrymë.',
      hintUncovered: 'Zona objektiv pa mbulim të mjaftueshëm: kontrolloni pozicionet ose planifikoni kamera shtesë.',
      hintPartial: 'Disa zona objektiv janë mbuluar vetëm pjesërisht – rregulloni këndin, pozicionin ose gamën.',
      hintDetailRange: 'Gama e detajeve të „{{name}}“ (përaf. {{range}} m) ndoshta nuk mjafton vetëm për dhoma të mëdha – një kamerë shtesë mund të jetë e dobishme.',
      hintPrivacy: 'Fusha e shikimit mbivendoset me një zonë private të shënuar. Duhet të kontrollohen pozicioni, orientimi ose maskimi teknik.',
      hintMount: 'Lartësia e montimit dhe kushtet e ndriçimit duhet të kontrollohen në vend.',
      hintKennzeichen: 'Kërkohet kontroll teknik dhe i mbrojtjes së të dhënave.',
      noteDetailRange:
        'Njohja e detajeve ndoshta nuk mjafton për përaf. {{distance}} m distancë – detaji maks. përaf. {{identification}} m. Duhet të kontrollohet një kënd më i ngushtë ose një model me rezolucion më të lartë.',
      noteDetailUncertain: 'Njohja e detajeve në distanca më të mëdha është e pasigurt – duhet të kontrollohen një kënd më i ngushtë dhe lartësia e montimit.',
      notePartial: 'Kjo zonë mund të jetë mbuluar vetëm pjesërisht.',
      suggestNear: 'Objektivi i vëzhgimit „{{target}}“ ndodhet afër „{{privacy}}“. Pozicioni dhe orientimi duhet të zgjidhen me kujdes – kërkohet kontroll i mbrojtjes së të dhënave.',
      suggestHeuristic: 'Sugjerimet janë heuristike. Çdo kamerë mund të zhvendoset, rrotullohet, ndryshohet ose fshihet lirisht.',
      suggestWide: 'Një kënd i gjerë shikimi nuk do të thotë njohje e mjaftueshme detajesh. Distanca, rezolucioni dhe lartësia e montimit ndikojnë në cilësinë e imazhit.',
      cameraNoteDetail: 'Pozicioni i parë i mundshëm i kamerës – planifikoni një kënd më të ngushtë për objektivat me detaje.',
      cameraNoteCheck: 'Pozicioni i parë i mundshëm i kamerës – ju lutemi kontrolloni dhe rregulloni.',
      cameraSuggestion: 'Sugjerim {{count}}',
      uncoveredPartial: 'pjesërisht',
      uncoveredInsufficient: 'i pamjaftueshëm',
      toastNoPositions: 'Nuk u gjetën pozicione të reja. Shtoni objektiva vëzhgimi ose dhoma.',
      toastSuggested: 'U sugjeruan {{count}} pozicion(e) i/e parë i/e mundshëm të kamerës.',
    },
  },
};